(() => {
  const money = (cents,currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-IE',{style:'currency',currency,minimumFractionDigits:cents % 100 ? 2 : 0}).format(cents/100);
  const emit = (name,data) => {
    // Optional events go through Shopify's consent-aware customer-events surface only.
    try {if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) window.Shopify.analytics?.publish?.(`typo_${name}`,data)?.catch?.(()=>{});} catch { /* Measurement must never block purchasing. */ }
  };
  const prefill = select => {
    select.value = 'Whole bean';
  };
  async function loadProduct(href) {
    const url=new URL(href,location.origin);
    if(url.origin!==location.origin || !/\/products\//.test(url.pathname))throw new Error('Please open the coffee page to choose your options.');
    url.searchParams.set('section_id','commerce-quick-shop');
    const response=await fetch(url,{cache:'no-store',signal:AbortSignal.timeout(15000)});
    if(!response.ok)throw new Error('This coffee could not be loaded. Please try its product page.');
    const fragment=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-quick-content]');
    if(!fragment)throw new Error('Quick shop is unavailable for this coffee. Please open its product page.');
    return {fragment,data:JSON.parse(fragment.querySelector('[data-quick-data]').textContent)};
  }
  const subscriptionChoice = (variant,allowedIds,selectedId,preferredName) => {
    const allocations=(variant?.allocations || []).filter(allocation=>allowedIds.includes(String(allocation.id)));
    return allocations.find(allocation=>String(allocation.id)===selectedId) || allocations.find(allocation=>allocation.name===preferredName) || allocations[0];
  };
  window.TypoShopping={emit,prefill,loadProduct,subscriptionChoice};
  document.addEventListener('click',event=>{if(event.target.closest('[data-drawer-checkout]')&&!window.CommerceBag?.busy())emit('drawer_checkout_start',{surface:'bag-drawer'});});
  function observeOffer(node,name,data) {
    if(!('IntersectionObserver' in window))return;
    const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){emit(name,data);observer.disconnect();}},{threshold:0.5});
    observer.observe(node);
  }

  function quickShop(dialog) {
    const body=dialog.querySelector('[data-quick-body]');
    let trigger=null, generation=0, busy=false;
    const close=()=>{if(!busy)dialog.close();};
    dialog.querySelector('[data-quick-close]').addEventListener('click',close);
    dialog.addEventListener('cancel',event=>{if(busy)event.preventDefault();});
    dialog.addEventListener('click',event=>{if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)close();}});
    dialog.addEventListener('close',()=>{
      generation++;
      document.documentElement.classList.remove('quick-shop-open');
      trigger?.setAttribute('aria-expanded','false');
      if(!document.querySelector('[data-cart-drawer][open]'))trigger?.focus({preventScroll:true});
    });
    dialog.addEventListener('keydown',event=>{
      if(event.key!=='Tab')return;
      const nodes=[...dialog.querySelectorAll('button:not([disabled]),a[href],select:not([disabled]),input:not([disabled])')].filter(n=>n.getClientRects().length);
      if(event.shiftKey&&document.activeElement===nodes[0]){event.preventDefault();nodes.at(-1)?.focus();}
      else if(!event.shiftKey&&document.activeElement===nodes.at(-1)){event.preventDefault();nodes[0]?.focus();}
    });
    document.addEventListener('click',async event=>{
      const link=event.target.closest('[data-quick-shop]');
      if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      if(!window.CommerceBag || typeof dialog.showModal!=='function')return;
      event.preventDefault();
      if(busy || window.CommerceBag.busy())return;
      trigger=link;
      link.setAttribute('aria-expanded','true');
      link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls',dialog.id);
      document.documentElement.classList.add('quick-shop-open');
      body.replaceChildren(Object.assign(document.createElement('p'),{className:'quick-shop__loading',textContent:'Loading your coffee...'}));
      dialog.showModal();
      const ticket=++generation;
      try {
        const {fragment,data}=await loadProduct(link.href);
        if(ticket!==generation || !dialog.open)return;
        body.replaceChildren(document.importNode(fragment,true));
        const form=body.querySelector('[data-quick-form]'), variant=form.querySelector('[data-quick-variant]'), grind=form.querySelector('[data-shopping-grind]'), quantity=form.querySelector('[name="quantity"]'), add=form.querySelector('[data-quick-add]'), error=form.querySelector('[data-shopping-error]');
        const currency=body.querySelector('[data-quick-content]').dataset.currency;
        prefill(grind);
        if(data.variants.length===1){variant.value=String(data.variants[0].id);variant.closest('label').hidden=true;const fixed=form.querySelector('[data-quick-fixed-size]');fixed.hidden=false;fixed.textContent=`Size: ${data.variants[0].title}`;}
        const selected=()=>data.variants.find(v=>String(v.id)===variant.value);
        const purchaseOptions=form.querySelector('[data-coffee-purchase-options]'), plan=form.querySelector('[data-commerce-plan]');
        const modes=[...form.querySelectorAll('[name="purchase-mode"]')], planOptions=plan?[...plan.options]:[], allowedIds=planOptions.map(option=>option.value).filter(Boolean);
        const price=body.querySelector('[data-quick-price]'), initialPrice=price.textContent;
        let preferredPlanName='';
        const subscribing=()=>modes.some(input=>input.checked&&input.value==='subscribe');
        if(purchaseOptions)purchaseOptions.hidden=false;
        const draw=()=>{
          const v=selected(), isSubscription=subscribing();
          const choice=subscriptionChoice(v,allowedIds,plan?.value,preferredPlanName);
          if(purchaseOptions){
            if(choice)preferredPlanName=choice.name;
            planOptions.forEach(option=>{const applicable=(v?.allocations || []).some(allocation=>String(allocation.id)===option.value);option.hidden=!applicable;option.disabled=!applicable;});
            plan.disabled=busy || !isSubscription || !choice;
            plan.required=isSubscription;
            plan.value=isSubscription&&choice?String(choice.id):'';
            modes.find(input=>input.value==='subscribe').disabled=busy || !choice;
            form.querySelector('[data-coffee-frequency]').hidden=!isSubscription || !choice;
            form.querySelector('[data-coffee-sub-unavailable]').hidden=!v || Boolean(choice);
            form.querySelector('[data-coffee-once-price]').textContent=v?money(v.price,currency):'Choose size';
            form.querySelector('[data-coffee-sub-price]').textContent=choice?money(choice.price,currency):v?'Unavailable':'Choose size';
            form.querySelector('[data-coffee-saving]').textContent=choice&&v.price?`${Math.round((v.price-choice.price)/v.price*100)}%`:'10%';
            form.querySelector('[data-coffee-sub-delivery]').textContent=v?.options.some(value=>/^1\s*kg$/i.test(value))
              ?'Free Republic of Ireland delivery on every 1kg subscription delivery. Northern Ireland rates apply.'
              :'Republic of Ireland delivery: €5, free at €40 after discounts. Each renewal qualifies separately. Northern Ireland rates apply.';
            form.querySelector('[data-quick-once-terms]').hidden=isSubscription;
            [...variant.options].forEach(option=>{
              const item=data.variants.find(item=>String(item.id)===option.value);
              if(!item)return;
              const itemPlan=subscriptionChoice(item,allowedIds,'',preferredPlanName);
              option.textContent=`${item.title} - ${money(isSubscription&&itemPlan?itemPlan.price:item.price,currency)}${!item.available?' (sold out)':isSubscription&&!itemPlan?' (one-time only)':''}`;
            });
          }
          const unitPrice=isSubscription?choice?.price:v?.price;
          add.disabled=busy || !v?.available || isSubscription&&!choice;
          form.querySelectorAll('[data-quick-quantity]').forEach(button=>button.disabled=busy);
          form.querySelector('[data-quick-add-label]').textContent=busy?'Adding...':v&&!v.available?'Sold out':v&&isSubscription&&!choice?'Unavailable':unitPrice!=null?`Add to bag - ${money(unitPrice*(Number(quantity.value)||1),currency)}`:'Choose size';
          price.textContent=unitPrice!=null?`${money(unitPrice,currency)}${isSubscription?' / delivery':''}`:initialPrice;
        };
        form.addEventListener('change',()=>{draw();emit('quick_shop_option',{product_id:data.id,variant_id:selected()?.id||null});});
        form.querySelectorAll('[data-quick-quantity]').forEach(button=>button.addEventListener('click',()=>{quantity.value=Math.max(1,(Number(quantity.value)||1)+Number(button.dataset.quickQuantity));draw();}));
        form.addEventListener('submit',async event=>{
          event.preventDefault();
          if(busy || add.disabled || !form.reportValidity() || !selected()?.available)return;
          const payload=new FormData(form);
          payload.delete('purchase-mode');
          if(!subscribing())payload.delete('selling_plan');
          if(subscribing()&&!selected().allocations?.some(allocation=>String(allocation.id)===payload.get('selling_plan')&&allowedIds.includes(String(allocation.id))))return;
          busy=true;error.hidden=true;draw();
          form.querySelectorAll('select,input').forEach(n=>n.disabled=true);
          try {
            const result=await window.CommerceBag.add(payload,link,{beforeOpen:()=>dialog.close()});
            if(result?.confirmed)emit('quick_shop_add',{product_id:data.id,variant_id:selected()?.id,quantity:Number(quantity.value),currency});
          } catch(failure){error.textContent=failure.message;error.hidden=false;}
          finally {busy=false;form.querySelectorAll('select,input').forEach(n=>n.disabled=false);draw();}
        });
        draw();emit('quick_shop_open',{product_id:data.id});
      } catch(failure){
        if(ticket!==generation)return;
        const message=Object.assign(document.createElement('p'),{className:'quick-shop__loading',textContent:failure.message});
        const fallback=Object.assign(document.createElement('a'),{className:'text-link',href:link.href,textContent:'Open coffee page'});
        body.replaceChildren(message,fallback);
      }
    });
  }
  function tasting(root) {
    const form=root.querySelector('[data-tasting-form]');
    if(!window.CommerceBag)return;
    form.hidden=false;
    let products=JSON.parse(root.querySelector('[data-tasting-data]').textContent), busy=false;
    const grind=form.querySelector('[data-shopping-grind]'), button=form.querySelector('button'), error=form.querySelector('[data-shopping-error]'), recovery=form.querySelector('[data-shopping-recovery]');
    const trials=rows=>rows.map(p=>p.variants.find(v=>v.available&&v.options.includes('250g')));
    const price=rows=>trials(rows).reduce((sum,v)=>sum+(v?.price||0),0);
    prefill(grind);
    observeOffer(root,'tasting_selection_view',{offer_id:'roastery-three'});
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(busy || window.CommerceBag.busy() || !form.reportValidity())return;
      busy=true;button.disabled=true;error.hidden=true;recovery.hidden=true;
      const selectedGrind=grind.value;
      grind.disabled=true;
      const label=button.querySelector('[data-tasting-add-label]');label.textContent='Checking the coffees...';
      try {
        const fresh=await Promise.all(products.map(async p=>(await loadProduct(p.url)).data));
        if(fresh.some(p=>p.requiresPlan)||trials(fresh).some(v=>!v))throw new Error('One of these 250g coffees is no longer available. Please choose from the coffee lineup.');
        const currentPrice=price(fresh), oldPrice=price(products);products=fresh;
        root.querySelector('[data-tasting-total]').textContent=money(currentPrice,root.dataset.currency);
        if(currentPrice!==oldPrice)throw new Error('The selection price has changed. Please review the updated total before adding.');
        const payload=new FormData();
        trials(products).forEach((v,i)=>{payload.set(`items[${i}][id]`,v.id);payload.set(`items[${i}][quantity]`,'1');payload.set(`items[${i}][properties][Grind]`,selectedGrind);payload.set(`items[${i}][properties][_typo_selection]`,'roastery-three');});
        const result=await window.CommerceBag.add(payload,button);
        if(result?.confirmed)emit('tasting_selection_add',{offer_id:'roastery-three',value:currentPrice/100,currency:root.dataset.currency,variant_ids:trials(products).map(v=>v.id)});
      } catch(failure){error.textContent=failure.message;error.hidden=false;recovery.hidden=false;}
      finally {busy=false;grind.disabled=false;button.disabled=false;label.textContent=`Add all three - ${money(price(products),root.dataset.currency)}`;}
    });
  }
  function start() {
    const dialog=document.querySelector('[data-quick-dialog]');
    if(dialog && !dialog.dataset.ready){dialog.dataset.ready='true';quickShop(dialog);}
    document.querySelectorAll('[data-tasting-selection]').forEach(root=>{if(!root.dataset.ready){root.dataset.ready='true';tasting(root);}});
    document.querySelectorAll('[data-tempo-addon-demo]').forEach(form=>{
      if(form.dataset.ready)return;form.dataset.ready='true';
      form.addEventListener('submit',event=>{event.preventDefault();if(!form.reportValidity())return;const output=form.querySelector('output');output.hidden=false;output.textContent='Preview selection only. Nothing has been added, charged or scheduled.';emit('tempo_addon_preview',{product_id:form.dataset.productId});});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();
